import { render, staticRenderFns } from "./SelectCat.vue?vue&type=template&id=53312600&"
import script from "./SelectCat.vue?vue&type=script&lang=js&"
export * from "./SelectCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports